<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Gl Level 1 Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <GlLevel1CheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Update Branch Status
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "GL Level 1 Checkers Queue",
    meta: [{ name: "GL Level 1 Checkers Queue", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "GL Level 1 Checkers Queue",
      items: [
        {
          text: "GL Level 1",
          href: "/"
        },
        {
          text: "GL Level 1 Checkers Queue",
          active: true
        }
      ]
    };
  }
};
</script>
